import { render, staticRenderFns } from "./Score.vue?vue&type=template&id=18b199f8&scoped=true"
import script from "./Score.vue?vue&type=script&lang=js"
export * from "./Score.vue?vue&type=script&lang=js"
import style0 from "./Score.vue?vue&type=style&index=0&id=18b199f8&prod&scoped=true&lang=css"
import style1 from "./Score.vue?vue&type=style&index=1&id=18b199f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b199f8",
  null
  
)

export default component.exports